<template>
  <span :style="{ fontSize: lablefont == '边框' ? '0' : '' }">
    <span v-for="(item2, index2) in footList" :key="index2">
      <span
        v-if="item2.label == '边框'"
        :style="{
          border: '1px solid #636363',
          padding: '2px 0',
        }"
      >
        <footNote
          :footList="item2.content"
          :changefontSize="changefontSize"
          lablefont="边框"
        ></footNote>
      </span>
      <span
        v-if="item2.label == 'text'"
        :style="{
          fontSize: 16 * (1 + changefontSize / 100) + 'px',
        }"
        v-html="brightenKeyword(item2.content, keyword)"
      ></span>
      <img
        v-if="item2.label == '图'"
        :src="baseImgPath + bookName + '/' + item2.content"
        :style="{
          margin: '0 auto',
          width: item2.widthsel,
          height: item2.hightsel,
        }"
        alt=""
      />
      <img
        v-if="item2.label == '字图'"
        :src="baseImgPath + bookName + '/' + item2.content"
        :style="{
          height: item2.size
            ? parseInt(16 * (1 + changefontSize / 100)) +
              parseInt(item2.size) +
              'px'
            : 16 * (1 + changefontSize / 100) + 'px',
          width: 'auto',
        }"
        alt=""
      />
      <span
        v-if="item2.label == '脚注小字'"
        :style="{
          fontSize: 12 * (1 + changefontSize / 100) + 'px',
        }"
        v-html="brightenKeyword(item2.content, keyword)"
      ></span>
      <span v-if="item2.label == '脚注段落'"><br /><br /></span>
      <span
        v-if="item2.label == 'xiaoji'"
        v-html="brightenKeyword(item2.content, keyword)"
      ></span>
    </span>
  </span>
</template>

<script>
export default {
  name: "footNote",
  props: {
    footList: [],
    changefontSize: 0,
    keyword: '',
    bookName: '',
    lablefont: ''
  }

}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/view/footNote.vue